import { Customer } from '@shared/composables/useCustomer/useCustomer';
import { User } from '@unified-commerce/gpc-vue-storefront-shopify';
import hash from 'object-hash';

interface Params {
  user?: User;
  customer?: Customer | null;
}
export const getHashedUserId = ({ user, customer }: Params) => {
  if (user?.id) {
    return hash(user.id);
  }
  if (customer?.id) {
    return hash(customer.id);
  }
  return '';
};
